module.exports = __webpack_public_path__ + "static/img/bb6.83d70a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bb6.png
// module id = NQF7
// module chunks = 2